/**
 * AD inbound directory detail — Groups tab URL search-param schema.
 *
 * See ad-inbound-users-search.ts for the `_` prefix rationale — the
 * Groups tab's pagination/filter params share the same URL as the
 * Users tab's, so they're namespaced to avoid collision.
 */

import { z } from "zod";
import { adDirectoryLinkSyncStatusSchema } from "./schemas";

export const adInboundGroupsSearchSchema = z.object({
  groups_offset: z.coerce.number().int().nonnegative().optional(),
  groups_sync_status: adDirectoryLinkSyncStatusSchema.optional(),
  groups_q: z.string().optional(),
});
export type AdInboundGroupsSearch = z.infer<typeof adInboundGroupsSearchSchema>;
